module.exports = __webpack_public_path__ + "static/media/invoice booking icon.14b416fd.svg";